/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FileStreamRes } from '../models/file-stream-res';
import { StockListingOptDataRes } from '../models/stock-listing-opt-data-res';
import { TrnChStockRecordExportReq } from '../models/trn-ch-stock-record-export-req';
import { TrnChStockRecordMoveReq } from '../models/trn-ch-stock-record-move-req';
import { TrnChStockRecordQueryReq } from '../models/trn-ch-stock-record-query-req';
import { TrnChStockRecordQueryRes } from '../models/trn-ch-stock-record-query-res';

@Injectable({
  providedIn: 'root',
})
export class StockListingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiStockListingOptDataGet
   */
  static readonly ApiStockListingOptDataGetPath = '/api/stock-listing/opt-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockListingOptDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockListingOptDataGet$Response(params?: {
  }): Observable<StrictHttpResponse<StockListingOptDataRes>> {

    const rb = new RequestBuilder(this.rootUrl, StockListingService.ApiStockListingOptDataGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StockListingOptDataRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockListingOptDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiStockListingOptDataGet(params?: {
  }): Observable<StockListingOptDataRes> {

    return this.apiStockListingOptDataGet$Response(params).pipe(
      map((r: StrictHttpResponse<StockListingOptDataRes>) => r.body as StockListingOptDataRes)
    );
  }

  /**
   * Path part for operation apiStockListingQueryPost
   */
  static readonly ApiStockListingQueryPostPath = '/api/stock-listing/query';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockListingQueryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingQueryPost$Response(params?: {
    body?: TrnChStockRecordQueryReq
  }): Observable<StrictHttpResponse<TrnChStockRecordQueryRes>> {

    const rb = new RequestBuilder(this.rootUrl, StockListingService.ApiStockListingQueryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TrnChStockRecordQueryRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockListingQueryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingQueryPost(params?: {
    body?: TrnChStockRecordQueryReq
  }): Observable<TrnChStockRecordQueryRes> {

    return this.apiStockListingQueryPost$Response(params).pipe(
      map((r: StrictHttpResponse<TrnChStockRecordQueryRes>) => r.body as TrnChStockRecordQueryRes)
    );
  }

  /**
   * Path part for operation apiStockListingExportPost
   */
  static readonly ApiStockListingExportPostPath = '/api/stock-listing/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockListingExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingExportPost$Response(params?: {
    body?: TrnChStockRecordExportReq
  }): Observable<StrictHttpResponse<FileStreamRes>> {

    const rb = new RequestBuilder(this.rootUrl, StockListingService.ApiStockListingExportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileStreamRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockListingExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingExportPost(params?: {
    body?: TrnChStockRecordExportReq
  }): Observable<FileStreamRes> {

    return this.apiStockListingExportPost$Response(params).pipe(
      map((r: StrictHttpResponse<FileStreamRes>) => r.body as FileStreamRes)
    );
  }

  /**
   * Path part for operation apiStockListingMoveRecordsPost
   */
  static readonly ApiStockListingMoveRecordsPostPath = '/api/stock-listing/move-records';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiStockListingMoveRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingMoveRecordsPost$Response(params?: {
    body?: TrnChStockRecordMoveReq
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, StockListingService.ApiStockListingMoveRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiStockListingMoveRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiStockListingMoveRecordsPost(params?: {
    body?: TrnChStockRecordMoveReq
  }): Observable<void> {

    return this.apiStockListingMoveRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
